module.exports = __webpack_public_path__ + "static/media/webchat.3af0e6ce.png";